const badges = [
    {
        name: 'michelin rated',
        img: 'https://i.imgur.com/SqAtyA5.png'
    },
    {
        name: 'black owned',
        img: 'https://i.imgur.com/JtQYrba.png'
    },
    {
        name: 'open late',
        img: 'https://i.imgur.com/466PcN4.png'
    },
    {
        name: 'paid parking',
        img: 'https://i.imgur.com/Ro31zwL.png'
    },
    {
        name: 'NFC mobile payments',
        img: 'https://i.imgur.com/EM4ZPgf.png'
    },
    {
        name: 'drive thru',
        img: 'https://i.imgur.com/XHMMJ93.png'
    },
    {
        name: 'outdoor seating',
        img: 'https://i.imgur.com/Tx8yXqF.png'
    },
    {
        name: 'vegetarian options',
        img: 'https://i.imgur.com/hhQvDVQ.png'
    },
    {
        name: 'alcohol available',
        img: 'https://i.imgur.com/WU6PYKZ.png'
    },
    {
        name: 'hookah',
        img: 'https://i.imgur.com/fDeryi7.png'
    },
    {
        name: 'live music',
        img: 'https://i.imgur.com/gh9CWvY.png'
    },
    {
        name: 'DJ',
        img: 'https://i.imgur.com/OClvUJL.png'
    },
    {
        name: 'cash only',
        img: 'https://i.imgur.com/ppDeNiZ.png'
    },
    {
        name: 'photogenic',
        img: 'https://i.imgur.com/nnX11fF.png'
    },
    {
        name: 'dog friendly',
        img: 'https://cdn-icons-png.flaticon.com/512/12/12638.png'
    }
]

export default badges;

